const ProfileServicesList = {
  computed: {
    ...Vuex.mapState(['profile', 'services']),
  },
  data() {
    return {};
  },
  created() {
    this.loading = true;
    this.$dmtk.services.get().then((data) => {
      this.$store.commit('set', data);
      this.loading = false;
    });
  },
  methods: {
    edit(service) {
      this.$router.push({ name: 'service.form', params: { id: service._id } });
    },
    deactivate(service) {
      UIkit.modal
        .confirm(
          '¿Seguro que deseas desactivar el servicio?\n\nSi lo haces ya no aparecerá en tu perfil.',
        )
        .then(() => {
          return this.$dmtk.services.deactivate(service._id);
        })
        .then((result) => {
          service.status = result.status;
        });
    },
    reactivate(service) {
      return this.$dmtk.services.reactivate(service._id).then((result) => {
        service.status = result.status;
      });
    },
    remove(service) {
      UIkit.modal
        .confirm(
          '¿Seguro que deseas borrar el servicio?\nEsta operación no podrá deshacerse',
        )
        .then((result) => {
          return this.$dmtk.services.delete(service._id);
        })
        .then((result) => {
          const idx = this.services.indexOf(service);
          if (idx >= 0) {
            this.services.splice(idx, 1);
          }
        });
    },
  },
  template: `
    <div>

      <div class="uk-text-center uk-margin-top uk-margin-medium-bottom">
        <router-link
          class="uk-button uk-button-dmtk"
          to="servicios/nuevo"
        >Añadir servicios
        </router-link>
      </div>
      
      <div class="uk-alert uk-alert-warning" v-if="!services.length">
        Aún no has añadido ningún servicio ¿a que esperas?
      </div>

      <div class="services-list -collapsed" v-if="services.length">
        <div class="service"
             :class="{ ['-'+service.status]: true }"
             v-for="service in services"
        >
          <div class="uk-grid">
            <div class="uk-width-expand info" @click="edit(service)">
              <strong>{{ service.title }}</strong><br>
              <span :title="service.createdAt | dateFormat">
                {{ service.createdAt | relativeTime }}
              </span>
            </div>
            <div>
              <button class="uk-button uk-button-ellipsis"></button>
              <div uk-dropdown="mode: click">
                <ul class="uk-nav uk-dropdown-nav">
                  <li v-if="service.status === 'active'">
                    <a :href="'/anuncios/'+service.slug+'/'" target="_blank">Ver</a>
                  </li>
                  <li>
                    <a @click="edit(service)">Editar servicio</a>
                  </li>
                  <li v-if="service.status === 'active'">
                    <a @click="deactivate(service)">Desactivar servicio</a>
                  </li>
                  <li v-if="service.status === 'inactive'">
                    <a @click="reactivate(service)">Reactivar servicio</a>
                  </li>
                  <li class="uk-nav-divider"></li>
                  <li>
                    <a @click="remove(service)" class="uk-text-danger">Borrar servicio</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  `,
};
